import React from 'react';

class Canvas extends React.Component {
    render () {
       return ( <canvas id="canvas" />)
    }
}


export default Canvas;